/** Friendly copy for the withdrawal-swap API's `extensions.code` values. */
const SWAP_ERROR_COPY: Record<string, string> = {
  QUOTE_REJECTED: 'This swap cannot be quoted for the chosen amount or pair. Try a different amount or asset.',
  QUOTE_UNAVAILABLE: 'A quote is temporarily unavailable. Please try again in a moment.',
  BELOW_MINIMUM: 'The amount is below the minimum swap size. Increase the amount.',
  SAME_ASSET: 'The destination is the same asset as the source. Choose "Same asset" or a different asset.',
  CHAIN_MISMATCH: 'The withdraw address is not on the destination chain. Pick a whitelisted address on that chain.',
  UNSUPPORTED_DESTINATION_CHAIN: 'That destination chain is not supported.',
  UNSUPPORTED_SOURCE: 'This token cannot be received as another asset.',
  NOT_FOUND: 'The destination asset or address could not be found. Reselect and try again.',
  INVALID_SLIPPAGE: 'Slippage must be between 0.10% and 5.00%.',
  SLIPPAGE_EXCEEDED: 'The price moved beyond your slippage limit. Refresh the quote or raise the limit.',
};

type ErrorLike = {
  graphQLErrors?: ReadonlyArray<{ extensions?: Record<string, unknown> }>;
} | null | undefined;

/** Never surfaces the raw server message. */
export function withdrawalSwapErrorMessage(error: ErrorLike, fallback: string): string {
  const code = error?.graphQLErrors?.[0]?.extensions?.code;
  return (typeof code === 'string' && SWAP_ERROR_COPY[code]) || fallback;
}
